import React, { useState, useEffect, useContext } from "react";
import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import {
  FaSearch,
  FaPrint,
  FaFilter,
  FaTimes,
  FaDownload,
  FaCar,
  FaGasPump,
  FaRoad,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import getCurrentSkin from "../utils/getCurrentSkin";

const VehicleHsdFillingReport = () => {
  const { isDark, skin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const primaryButtonClass = `bg-${baseColor}-${baseShade} hover:bg-${baseColor}-700 text-white`;
  const secondaryButtonClass = "bg-gray-200 hover:bg-gray-300 text-gray-800";
  const navigate = useNavigate();

  // ✅ localStorage values
  const finYearId = localStorage.getItem("finYearId") || "";
  const finYear = localStorage.getItem("finYear") || "";
  const storedBranchId = localStorage.getItem("branchId") || "";
  const storedBranchType = localStorage.getItem("branchType") || "HO";
  const userId = localStorage.getItem("userId") || "";

  // ✅ common headers
  const commonHeaders = {
    "x-finyearid": finYearId,
    "x-finyear": finYear,
    "x-branchid": storedBranchId,
    "x-branch": storedBranchType,
    "x-userid": userId,
  };

  const [showFilters, setShowFilters] = useState(true);
  const [loading, setLoading] = useState(false);

  const [branchType, setBranchType] = useState(storedBranchType || "HO");
  const [branchId, setBranchId] = useState(storedBranchId || "8");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [vehicleRegNo, setVehicleRegNo] = useState("");
  const [vehicleCode, setVehicleCode] = useState("");
  const [vehicleName, setVehicleName] = useState("");
  const [vehicleMainType, setVehicleMainType] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const [branchList, setBranchList] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [data, setData] = useState([]);

  const monthOptions = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Fetch branch list
  useEffect(() => {
    setLoading(true);

    axios
      .get("https://nissi-india.com/api/fillbranch_hsdRpt", {
        params: {
          branchid: storedBranchId || branchId || 8,
          branchtype: branchType || storedBranchType || "HO",
        },
        headers: commonHeaders,
      })
      .then((res) => {
        const branches = res.data.branchList || [];
        setBranchList(branches);

        if (branches.length > 0 && !selectedBranch) {
          setSelectedBranch(String(branches[0].fld_Branchid || ""));
        }
      })
      .catch((err) => {
        console.error("Dropdown fetch failed", err);
        toast.error("Failed to load branches");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [branchType, branchId]);

  // Fetch years
  useEffect(() => {
    axios
      .get("https://nissi-india.com/api/hsd_years", {
        headers: commonHeaders,
      })
      .then((res) => {
        setYearList(res.data || []);
      })
      .catch((err) => {
        console.error("Years fetch failed", err);
      });
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleSearch = () => {
    if (!fromDate || !toDate) {
      toast.error("Please select From Date and To Date");
      return;
    }

    setLoading(true);

    const params = {
      branchid: storedBranchId || branchId || 8,
      branchtype: branchType || storedBranchType || "HO",
      searchBranch: selectedBranch || branchId || storedBranchId || 8,
      vehicleCode: vehicleCode || "",
      vehicleName: vehicleName || "",
      vehicleRegNo: vehicleRegNo || "",
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      month: month || "Select",
      year: year || "Select",
      vehicletypeIndex: "Select",
      vehicleType: branchType === "HO" ? "O" : "H",
    };

    axios
      .get("https://nissi-india.com/api/hsd_filling_report", {
        params,
        headers: commonHeaders,
      })
      .then((res) => {
        const responseData =
          res.data.data && Array.isArray(res.data.data) ? res.data.data : [];
        setData(responseData);
        toast.success(`Loaded ${responseData.length} records`);
      })
      .catch((err) => {
        console.error("HSD Report fetch failed", err);
        toast.error("Failed to fetch HSD report");
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePrint = () => {
    const params = {
      branchid: storedBranchId || branchId || 8,
      branchtype: branchType || storedBranchType || "HO",
      searchBranch: selectedBranch || branchId || storedBranchId || 8,
      vehicleCode: vehicleCode || "",
      vehicleName: vehicleName || "",
      vehicleRegNo: vehicleRegNo || "",
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      month: month || "Select",
      year: year || "Select",
      vehicletypeIndex: "Select",
      vehicleType: branchType === "HO" ? "O" : "H",
    };

    const query = new URLSearchParams(params).toString();
    window.open(`/inventory/vehiclehsdfillingReport_AllPrint?${query}`, "_blank");
  };

  const clearFilters = () => {
    setBranchType(storedBranchType || "HO");
    setBranchId(storedBranchId || "8");
    setFromDate("");
    setToDate("");
    setVehicleRegNo("");
    setVehicleCode("");
    setVehicleName("");
    setVehicleMainType("");
    setSelectedBranch("");
    setMonth("");
    setYear("");
    setData([]);
  };

  const formatNumber = (value) => {
    return value
      ? parseFloat(value).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00";
  };

  return (
    <LayoutWrapper>
      <HeaderBar title="VEHICLE HSD FILLING HR/KM REPORT" />
      <ToastContainer />

      <div
        className={`p-6 mt-6 rounded-xl shadow-sm border ${
          isDark
            ? "bg-gray-800 border-gray-700 text-white"
            : "bg-white border-gray-200 text-gray-900"
        }`}
      >
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-6 gap-4">
          <div>
            <h1 className="text-2xl font-bold">Vehicle HSD Filling Report</h1>
            <p className="text-sm text-gray-500 mt-1">
              Track and analyze vehicle fuel consumption and performance metrics
            </p>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setShowFilters(!showFilters)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
                showFilters ? primaryButtonClass : secondaryButtonClass
              }`}
            >
              <FaFilter className="w-4 h-4" />
              {showFilters ? "Hide Filters" : "Show Filters"}
            </button>

            <button
              className={`flex items-center gap-2 px-4 py-2 rounded-lg ${secondaryButtonClass}`}
            >
              <FaDownload className="w-4 h-4" />
              Export
            </button>
          </div>
        </div>

        {/* Vehicle Type Selection */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-3">Vehicle Type</label>
          <div className="flex gap-2">
            <button
              onClick={() => setBranchType("HO")}
              className={`px-6 py-2 rounded-lg font-medium transition-colors ${
                branchType === "HO" ? primaryButtonClass : secondaryButtonClass
              }`}
            >
              Own Vehicle
            </button>
            <button
              onClick={() => setBranchType("Branch")}
              className={`px-6 py-2 rounded-lg font-medium transition-colors ${
                branchType === "Branch"
                  ? primaryButtonClass
                  : secondaryButtonClass
              }`}
            >
              Hire Vehicle
            </button>
          </div>
        </div>

        {/* Filters Section */}
        {showFilters && (
          <div
            className={`rounded-lg p-5 mb-6 ${
              isDark ? "bg-gray-700" : "bg-gray-50"
            }`}
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Search Filters</h3>
              <button
                onClick={clearFilters}
                className="text-sm text-gray-500 hover:text-gray-700 flex items-center gap-1"
              >
                <FaTimes className="w-3 h-3" /> Clear all
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-5">
              <div>
                <label className="block text-sm font-medium mb-2">
                  From Date *
                </label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white border-gray-300"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  To Date *
                </label>
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white border-gray-300"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Vehicle Registration No
                </label>
                <input
                  type="text"
                  value={vehicleRegNo}
                  onChange={(e) => setVehicleRegNo(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white border-gray-300"
                  placeholder="Enter registration number"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Vehicle Code
                </label>
                <input
                  type="text"
                  value={vehicleCode}
                  onChange={(e) => setVehicleCode(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white border-gray-300"
                  placeholder="Enter vehicle code"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Vehicle Name
                </label>
                <input
                  type="text"
                  value={vehicleName}
                  onChange={(e) => setVehicleName(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white border-gray-300"
                  placeholder="Enter vehicle name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Branch</label>
                <select
                  value={selectedBranch}
                  onChange={(e) => setSelectedBranch(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white border-gray-300"
                >
                  <option value="">All Branches</option>
                  {branchList.map((b) => (
                    <option key={b.fld_Branchid} value={b.fld_Branchid}>
                      {b.fld_BranchName}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Month</label>
                <select
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white border-gray-300"
                >
                  <option value="">Select Month</option>
                  {monthOptions.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Year</label>
                <select
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white border-gray-300"
                >
                  <option value="">Select Year</option>
                  {yearList.map((y) => (
                    <option key={y.value} value={y.value}>
                      {y.text}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-end pt-4 border-t border-gray-200">
              <button
                onClick={handleSearch}
                className={`flex items-center gap-2 ${primaryButtonClass} px-4 py-2 rounded transition-colors`}
              >
                <FaSearch className="w-4 h-4" />
                Search
              </button>
              <button
                onClick={handlePrint}
                className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded transition-colors"
              >
                <FaPrint className="w-4 h-4" />
                Print Report
              </button>
            </div>
          </div>
        )}

        {/* Results Section */}
        <div>
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">
              Results {data.length > 0 && `(${data.length} records)`}
            </h2>

            {data.length > 0 && (
              <span className="text-sm text-gray-500">
                Last updated: {new Date().toLocaleTimeString()}
              </span>
            )}
          </div>

          {loading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : data.length > 0 ? (
            <div className="overflow-x-auto rounded-lg border border-gray-200">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      S.No
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Vehicle Code
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Vehicle Name
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Reg No
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Working Hrs
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      HSD (Hrs)
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Working Km
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      HSD (Km)
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Diesel/Hr
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Diesel/Km
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Last Updated
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {data.map((item, index) => (
                    <tr
                      key={index}
                      className="hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {index + 1}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.fld_vehicle_code}
                      </td>
                      <td
                        onClick={() =>
                          navigate("/inventory/Vehiclehsdfilling_Report1", {
                            state: item,
                          })
                        }
                        className="px-4 py-4 text-sm font-medium text-blue-600 cursor-pointer hover:underline"
                      >
                        {item.fld_vehicle_name}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.fld_vehicle_regno}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">
                        {formatNumber(item.fld_hsdfillingWorkinhr)}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">
                        {formatNumber(item.fld_hsdfillinghr)}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">
                        {formatNumber(item.fld_hsdfillingWorkingKM)}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">
                        {formatNumber(item.fld_hsdfillingkm)}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-green-600 text-right">
                        {formatNumber(item.fld_diselconsumptionhr)}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-green-600 text-right">
                        {formatNumber(item.fld_diselconsumptionkm)}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.fld_progressentrydate}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-12 bg-gray-50 rounded-lg border border-dashed border-gray-300">
              <div className="flex justify-center">
                <FaCar className="h-12 w-12 text-gray-400 mr-4" />
                <FaGasPump className="h-12 w-12 text-gray-400 mr-4" />
                <FaRoad className="h-12 w-12 text-gray-400" />
              </div>
              <h3 className="mt-2 text-sm font-medium text-gray-900">
                No vehicle HSD records found
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                Get started by searching with the filters above.
              </p>
            </div>
          )}
        </div>
      </div>
    </LayoutWrapper>
  );
};

export default VehicleHsdFillingReport;